import axios from 'axios'

export default
{
    /**
     * user login
     *
     * @params {login}
     * @params {password}
     * @return {object}
     */
    async login(login, password)
    {
        let query = `{ login(login: "${login}", password: "${password}") { id first_name last_name email login token existed_role employee_id customer_id avatar(size: 80) } } `

        return await axios.post('', {query: query})
    },

}
